<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" style="background-image: url(assets/images/commercial-bg.jpg);">
        <div class="container">
            <div class="commercial-top-tab-list ">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/club" >How To Find Us </a></li>
                            <li><a routerLink="/ground-regulations" >Ground Regulations</a></li>
                            <li><a routerLink="/access-statement" class="active">Access Statement</a></li>
                            <li><a routerLink="/recruitment">Recruitment</a></li>
                            <li><a routerLink="/governance"> Governance</a></li>                                                          
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">
        </div>
    </div>
    <div class="club-hero-section cf">
        <div class="container">
            <div class="club-hero-detail" *ngFor="let access of accessList?.data">
                <div class="club-hero-btn">
                    <a href="{{access?.pdf}}">{{access?.title}}</a>
                </div>
                <div class="club-hero-content" [innerHTML]="access?.description">
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->